import { Stack } from '@mui/material';
import { memo } from 'react';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { getRecordTypeIdentifier } from '../../../pages/configuration-canvas/utils/getRecordTypeIdentifier';
import { CardContent } from './CardContent';
import {
  DocumentationCardItem,
  DocumentationCardContentViewType,
} from '../../salesforce-documentation-card/types';
import { isFieldConfigurationItem, SalesforceItem } from '../../../parser/ConfigurationItemTypes';
import { humanizeDate } from '../../../helpers/humanizeDate';
import { isItemActive } from '../../helpers';
interface CardListItemProps {
  item: SalesforceItem;
  activeMetadataId?: string;
  handleSetConfigurationItem: (props: DocumentationCardItem) => void;
  withDetailedContentForRelatedObjects?: boolean;
  withApiNameOnHover?: boolean;
}

export const CardListItem = memo(
  ({
    item,
    activeMetadataId,
    handleSetConfigurationItem,
    withDetailedContentForRelatedObjects: withDetailedContent,
    withApiNameOnHover,
  }: CardListItemProps) => {
    return (
      <Stack key={'wrapper_' + item.metadataId}>
        <ListElementWrapper
          elementId={getRecordTypeIdentifier(item.name, item.objectApiNames?.[0])}
          sx={{
            minHeight: '64px',
            pr: 0,
            pl: 0,
            pt: 1.5,
            pb: 1.5,
          }}
          onWrapperClick={() => {
            handleSetConfigurationItem({
              item,
              clearHistory: true,
              contentType: DocumentationCardContentViewType.default,
            });
          }}
          isHighlighted={activeMetadataId ? activeMetadataId === item.metadataId : false}
          leftContent={
            <CardContent
              parentType={item.parentType}
              label={item.label}
              apiName={item.name}
              date={humanizeDate({ dateOrTimestamp: item.updatedAt ?? '' })}
              isActive={isItemActive(item)}
              objectNames={item.relatedObjects}
              parentObject={item.objectApiNames?.[0]}
              dependencyType={isFieldConfigurationItem(item) ? item.fieldType : ''}
              withDetailedContentForRelatedObjects={withDetailedContent}
              withApiNameOnHover={withApiNameOnHover}
            />
          }
        />
      </Stack>
    );
  },
);

CardListItem.displayName = 'CardListItem';
